// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const empty: MarkdocFunctionSchema = {
  render(parameters): boolean {
    const [array] = Object.values(parameters);
    return Array.isArray(array) ? array.length === 0 : false;
  },
};
